const SIGNER_TEXT_BASE = "agreements_internal_signer_header_text";
const SIGNER_ENABLED_BASE = "agreements_internal_signer_header_text_enabled";

export const signerTextKey = (templateId: number) => `${SIGNER_TEXT_BASE}_${templateId}`;
export const signerEnabledKey = (templateId: number) => `${SIGNER_ENABLED_BASE}_${templateId}`;

export const parseCustomTemplateIds = (settings: { name: string; content: string }[]): number[] => {
    const setting = settings.find((s) => s.name === "agreements_signer_custom_template_ids");
    if (!setting?.content) return [];
    try {
        const parsed = JSON.parse(setting.content);
        return Array.isArray(parsed) ? parsed.filter((id): id is number => typeof id === "number") : [];
    } catch {
        return [];
    }
};

export const getTemplateSignerText = (settings: { name: string; content: string }[], templateId: number): string =>
    settings.find((s) => s.name === signerTextKey(templateId))?.content ?? "";

export const getTemplateSignerEnabled = (
    settings: { name: string; content: string }[],
    templateId: number,
): boolean => {
    if (!parseCustomTemplateIds(settings).includes(templateId)) return false;
    return settings.some((s) => s.name === signerEnabledKey(templateId) && +s.content === 1);
};
